// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"az_ks","spin":"az_ls","spinnerWrapper":"az_ms","spinner":"az_ns"};